// extracted by mini-css-extract-plugin
export default {"printerButtonGroup":"styles_printerButtonGroup__oG58F","linkContainer":"styles_linkContainer__5Q75h","link":"styles_link__0gocz"};